// source: https://blog.abelotech.com/posts/number-currency-formatting-javascript/

type Functions = 'round' | 'floor' | 'ceil' | 'abs';
const thousandSeparator = (num: any, clearFunc: Functions | Functions[] | null = 'round') => {
  let cleared = num;
  if (clearFunc) {
    const functions = typeof clearFunc === 'string' ? [ clearFunc ] : clearFunc;
    cleared = functions.reduce((acc, func) => Math[func](acc), (num || 0));
  }
  return String(cleared || 0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export default thousandSeparator;
